import ProxyPlatforms from "../../../../contents/docs/advanced/proxy/_snippets/proxy-platforms";
import ProxyDecisionTree from "../../../../contents/docs/advanced/proxy/_snippets/proxy-decision-tree";
import ManagedReverseProxy from "../../../../contents/docs/advanced/proxy/_snippets/managed-reverse-proxy.mdx";
import * as React from 'react';
export default {
  ProxyPlatforms,
  ProxyDecisionTree,
  ManagedReverseProxy,
  React
};